import { render } from "./App.vue?vue&type=template&id=29adf72b&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=29adf72b&lang=css"
import "./App.vue?vue&type=style&index=1&id=29adf72b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-29adf72b"

export default script